<template>
  <div>
    <cbr-manual-form 
      :form-data="formData" 
      :config="config"/>
    
    <cbr-choose-return-method 
      v-show="formIsValid"/>

    <cbr-summary 
      v-show="formIsValid"/>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';

  import CbrManualForm from '../components/CbrManualForm.vue';
  import CbrChooseReturnMethod from '../components/CbrChooseReturnMethod.vue';
  import CbrSummary from '../components/CbrSummary.vue';

  export default {

    components: {
      CbrManualForm,
      CbrChooseReturnMethod,
      CbrSummary,
    },

    computed: {
      ...mapState('config', [
          'config',
        ]
      ),
      ...mapState('inputData', [
        'formData',
      ]),
      ...mapGetters('inputData', [
        'formIsValid',
      ]),
    },
  }
</script>


// WEBPACK FOOTER //
// client/views/ManualEntryPage.vue